import { FormatLabelFn } from '@@partner:types:app'

export const formatCustomerPaymentCardType: FormatLabelFn<string> = (
  card_type
) => {
  switch (card_type) {
  case 'bank_card':
  case 'card':
    return { label: 'Банковская карта', color: 'cyan' }
  default:
    return { label: `Неопределён: ${card_type}`, color: 'red' }
  }
}

export const formatCustomerCardIssuerCountry: FormatLabelFn<string> = (
  country
) => {
  switch (country) {
  case 'US':
    return { label: 'США', color: 'cyan' }
  case 'RU':
    return { label: 'Россия', color: 'green' }
  case 'BY':
    return { label: 'Беларусь', color: 'blue' }
  case 'KZ':
    return { label: 'Казахстан', color: 'yellow' }
  case 'CN':
    return { label: 'Китай', color: 'violet' }
  default:
    return { label: `Неопределена: ${country}`, color: 'red' }
  }
}
